// extracted by mini-css-extract-plugin
export default {"content_skillGroup":"SkillGroup_content_skillGroup__8YemJ","pGroup":"SkillGroup_pGroup__KjNDn"};